/**
 * InsCoder 2026-07-02 B + PDP Slider - Swiper initialization
 * PC: 3 cards per view, bottom nav bar with progress + arrows
 * MB: 280px cards auto, swipe only
 */

document.addEventListener('DOMContentLoaded', function () {
  var sliderEls = document.querySelectorAll('[data-cust-pdp-slider]');

  sliderEls.forEach(function (sliderEl) {
    var container = sliderEl.closest('.cust-pdp-slider__container');
    var navBar = container ? container.querySelector('.cust-pdp-slider__nav-bar') : null;
    var prevBtn = navBar ? navBar.querySelector('.cust-pdp-slider__arrow--prev') : null;
    var nextBtn = navBar ? navBar.querySelector('.cust-pdp-slider__arrow--next') : null;

    var swiperConfig = {
      slidesPerView: 1.2,
      slidesPerGroup: 1,
      spaceBetween: 14,
      // Enable trackpad (wheel-event) horizontal swipe
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        thresholdDelta: 30,
        thresholdTime: 500,
      },
      breakpoints: {
        750: {
          slidesPerView: 3.1,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
      },
    };

    if (prevBtn && nextBtn) {
      swiperConfig.navigation = {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'swiper-button-disabled',
      };
    }

    // Progress bar: inject fill element + update on slide change
    var progressTrack = navBar ? navBar.querySelector('.cust-pdp-slider__progress-track') : null;
    if (progressTrack && !progressTrack.querySelector('.cust-pdp-slider__progress-fill')) {
      var fill = document.createElement('div');
      fill.className = 'cust-pdp-slider__progress-fill';
      progressTrack.appendChild(fill);
    }

    swiperConfig.on = {
      init: function () {
        updateProgress(this);
      },
      slideChange: function () {
        updateProgress(this);
      },
    };

    var swiper = new Swiper(sliderEl, swiperConfig);

    function updateProgress(swiperInstance) {
      var fill = progressTrack ? progressTrack.querySelector('.cust-pdp-slider__progress-fill') : null;
      if (!fill) return;
      var totalSlides = swiperInstance.slides.length;
      if (totalSlides === 0) return;
      // slidesPerView may be 'auto' on mobile, use actual visible count
      var perView = swiperInstance.params.slidesPerView === 'auto'
        ? swiperInstance.slidesPerViewDynamic()
        : swiperInstance.params.slidesPerView;
      // Progress = (already-scrolled + currently-visible) / total
      var progressPct = ((swiperInstance.activeIndex + perView) / totalSlides) * 100;
      fill.style.width = Math.min(progressPct, 100).toFixed(2) + '%';
    }
  });
});

/**
 * InsCoder 2026-07-02 E + PDP Slider - Swiper initialization
 */
